import {
  Create,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  TextInput,
  SimpleForm,
  FileInput,
  FileField,
  useRedirect,
  useNotify,
} from "react-admin";
export default function GenerCreate(props) {
  const redirect = useRedirect();
  const notify = useNotify();
  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="name" placeholder="gener name" />
      </SimpleForm>
    </Create>
  );
}
